import { useFormContext } from "react-hook-form";
import { Radio } from "@circle-react-uikit/Radio";
import type { TemplateFieldProps } from "./CreateTemplateField";

export const UpdateTemplateField = ({
  name,
  value,
  label,
  checked,
}: TemplateFieldProps) => {
  const { resetField, clearErrors } = useFormContext();

  return (
    <div className="flex w-full flex-col gap-y-6">
      <Radio
        id={`${name}-radio-${value}`}
        label={label}
        checked={checked}
        labelClassName="m-0 text-base font-normal leading-5 normal-case text-dark"
        labelWrapperClassName="ml-4 w-full"
        onClick={() => {
          resetField("name");
          clearErrors("name");
        }}
      />
    </div>
  );
};
